import { render, staticRenderFns } from "./lastfmCallback.vue?vue&type=template&id=2925758b&scoped=true"
import script from "./lastfmCallback.vue?vue&type=script&lang=js"
export * from "./lastfmCallback.vue?vue&type=script&lang=js"
import style0 from "./lastfmCallback.vue?vue&type=style&index=0&id=2925758b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2925758b",
  null
  
)

export default component.exports